// PayDirt API — Betting endpoints

import { apiFetch } from './client';

export const placeBetAPI = (userId, marketId, side, amount) =>
  apiFetch('/api/bets', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ userId, marketId, side, amount }),
  });
